export default __webpack_public_path__ + "static/media/hunter-hunter.6f071b93.jpg";